import { Routes } from '@angular/router';
import { ChatAiComponent } from 'app/ChatAi/ChatAi/ChatAi.component';
import {MeasurerdashboardComponent} from 'app/measurerdashboard/measurerdashboard.component';


export const MeasurerLayoutRoutes: Routes = [
  { path: 'measurerdashboard', component: MeasurerdashboardComponent},
        { path: 'dr-mo-ai-measurer', component: ChatAiComponent },
  
];
